import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppFooterComponent } from 'app/app-footer/app-footer.component';
import { AppHeaderComponent } from 'app/app-header/app-header.component';
import { BodyComponent } from 'app/body/body.component';
import { BodyRoutingModule } from 'app/body/body.routing.module';
import { ExtratoComponent } from 'app/extrato/extrato.component';
import { HomeComponent } from 'app/home/home.component';
import { LojaCarrinhoComponent } from 'app/loja/loja-carrinho/loja-carrinho.component';
import { LojaVitrineComponent } from 'app/loja/loja-vitrine/loja-vitrine.component';
import { LojaComponent } from 'app/loja/loja.component';
import { PedidoComponent } from 'app/loja/pedido/pedido.component';
import { FaqComponent } from 'app/menu-superior/faq/faq.component';
import { EpwdResetComponent } from 'app/menu-superior/meu-cadastro/epwd-reset/epwd-reset.component';
import { EpwdComponent } from 'app/menu-superior/meu-cadastro/epwd/epwd.component';
import { FormComponent } from 'app/menu-superior/meu-cadastro/form/form.component';
import { MeuCadastroComponent } from 'app/menu-superior/meu-cadastro/meu-cadastro.component';
import { SubmenuComponent } from 'app/menu-superior/meu-cadastro/submenu/submenu.component';
import { AnexosComponent } from 'app/menu-superior/sac/anexos/anexos.component';
import { DetalheComponent } from 'app/menu-superior/sac/detalhe/detalhe.component';
import { SacFormComponent } from 'app/menu-superior/sac/form/sac-form.component';
import { SacComponent } from 'app/menu-superior/sac/sac.component';
import { ConfirmacaoNovoPagamentoComponent } from 'app/pagamento/confirmacao-novo-pagamento/confirmacao-novo-pagamento.component';
import { NovoPagamentoComponent } from 'app/pagamento/novo-pagamento/novo-pagamento.component';
import { PagamentoComponent } from 'app/pagamento/pagamento.component';
import { ModalPoliticaTermoComponent } from 'app/politica-termo/modal-politica-termo/modal-politica-termo.component';
import { PoliticaTermoComponent } from 'app/politica-termo/politica-termo.component';
import { NovaRecargaComponent } from 'app/recarga/nova-recarga/nova-recarga.component';
import { RecargaComponent } from 'app/recarga/recarga.component';
import { ComponentesModule } from 'app/resources/componentes/componentes.module';
import { DiretivesModule } from 'app/resources/diretives/diretives.module';
import { BoletoPipe } from 'app/resources/pipes/boleto.pipe';
import { CartaoPipe } from 'app/resources/pipes/cartao.pipe';
import { CurrencyFormatPipe } from 'app/resources/pipes/currency-format.pipe';
import { DateFormatPipe } from 'app/resources/pipes/date-format.pipe';
import { KeyOfValuePipe } from 'app/resources/pipes/key-of-value.pipe';
import { LimitToPipe } from 'app/resources/pipes/limit-to.pipe';
import { OrderByPipe } from 'app/resources/pipes/order-by.pipe';
import { PagamentoPipe } from 'app/resources/pipes/pagamento.pipe';
import { PontosPipe } from 'app/resources/pipes/pontos.pipe';
import { TributoPipe } from 'app/resources/pipes/tributo.pipe';
import { SpinnerComponent } from 'app/spinner/spinner.component';
import { BancariaComponent } from 'app/transferencia/bancaria/bancaria.component';
import { BandeiradoComponent } from 'app/transferencia/bandeirado/bandeirado.component';
import { CartaoComponent } from 'app/transferencia/cartao/cartao.component';
import { TransferenciaComponent } from 'app/transferencia/transferencia.component';
import { CestaComponent } from 'app/vale-presente/cesta/cesta.component';
import { ParceirosComponent } from 'app/vale-presente/parceiros/parceiros.component';
import { ValePedidoComponent } from 'app/vale-presente/vale-pedido/vale-pedido.component';
import { ValePresenteComponent } from 'app/vale-presente/vale-presente.component';
import { VitrineComponent } from 'app/vale-presente/vitrine/vitrine.component';
import { VoucherConfirmarComponent } from 'app/voucher/voucher-confirmar/voucher-confirmar.component';
import { VoucherDadosTransferenciaComponent } from 'app/voucher/voucher-dados-transferencia/voucher-dados-transferencia.component';
import { VoucherListaAdicionaisComponent } from 'app/voucher/voucher-resgatar/voucher-lista-adicionais/voucher-lista-adicionais.component';
import { VoucherResgatarComponent } from 'app/voucher/voucher-resgatar/voucher-resgatar.component';
import { VoucherSucessoComponent } from 'app/voucher/voucher-sucesso/voucher-sucesso.component';
import { VoucherTituloComponent } from 'app/voucher/voucher-titulo/voucher-titulo.component';
import { ContaBancariaPipe } from '../resources/pipes/conta-bancaria.pipe';
import { NovoPagamentoLoteComponent } from 'app/pagamento/novo-pagamento-lote/novo-pagamento-lote.component';
import { NovoPagamentoIndividualComponent } from 'app/pagamento/novo-pagamento-individual/novo-pagamento-individual.component';

@NgModule({
  imports: [
    CommonModule,
    BodyRoutingModule,
    FormsModule,
    ComponentesModule,
    DiretivesModule
  ],
  declarations: [
    AppHeaderComponent,
    AppFooterComponent,
    CartaoPipe,
    PagamentoPipe,
    PontosPipe,
    BoletoPipe,
    TributoPipe,
    HomeComponent,
    ExtratoComponent,
    PagamentoComponent,
    TransferenciaComponent,
    BancariaComponent,
    ValePresenteComponent,
    RecargaComponent,
    LojaComponent,
    BodyComponent,
    NovoPagamentoComponent,
    NovoPagamentoIndividualComponent,
    NovoPagamentoLoteComponent,
    MeuCadastroComponent,
    ConfirmacaoNovoPagamentoComponent,
    SubmenuComponent,
    EpwdComponent,
    EpwdResetComponent,
    ContaBancariaPipe,
    FormComponent,
    ParceirosComponent,
    VitrineComponent,
    CestaComponent,
    ValePedidoComponent,
    NovaRecargaComponent,
    OrderByPipe,
    PedidoComponent,
    LojaVitrineComponent,
    KeyOfValuePipe,
    LojaCarrinhoComponent,
    CartaoComponent,
    BandeiradoComponent,
    SacComponent,
    SacFormComponent,
    DetalheComponent,
    AnexosComponent,
    FaqComponent,
    LimitToPipe,
    DateFormatPipe,
    CurrencyFormatPipe,
    VoucherSucessoComponent,
    VoucherConfirmarComponent,
    VoucherResgatarComponent,
    VoucherListaAdicionaisComponent,
    VoucherDadosTransferenciaComponent,
    VoucherTituloComponent,
    SpinnerComponent,
    ModalPoliticaTermoComponent,
    PoliticaTermoComponent
  ],
  exports: [
    MeuCadastroComponent,
    SubmenuComponent,
    EpwdComponent,
    EpwdResetComponent,
    ContaBancariaPipe,
    FormComponent
  ]
})
export class BodyModule { }



// WEBPACK FOOTER //
// ./src/app/body/body.module.ts